import { ContentFlexComponent, ContentProps } from "components/flexComponents/Content/typings";
import { ContentComponent } from "components/flexComponents/Content/factory/ContentComponent";
import * as React from "react";
import { DynamicVendorContentFlexModule } from "typings/microserviceModels/content-flex-module";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { RenderAbleContentItem } from "components/flexComponents/Content/factory/impl/items/RenderAbleContentItem";

export class DynamicVendorContent extends ContentComponent {
  public readonly dynamicVendorContent: DynamicVendorContentFlexModule;

  constructor(dynamicVendorContent: ContentFlexComponent) {
    super(dynamicVendorContent);
    this.dynamicVendorContent = dynamicVendorContent.model as DynamicVendorContentFlexModule;
    this.keyHelper = new ItemKeyHelper("dynamicVendorContent");
  }

  public shouldRender = (): boolean => (this.dynamicVendorContent?.content?.body?.length || 0) > 0;

  public getId = (): string => this.dynamicVendorContent.content.id;

  public generate(props: ContentProps) {
    const classNameAttr = `${this.getEditorialItemClassName()}`;

    return (
      <div
        className={classNameAttr}
        id={this.flexComponent.id}
        data-fm={this.flexComponent.fmId}
        data-fm-title-id={this.flexComponent.fmTitleId}
      >
        <RenderAbleContentItem
          id={this.dynamicVendorContent.content.id}
          text={this.dynamicVendorContent.content.body}
          title={this.dynamicVendorContent.content.title}
          key={`${this.keyHelper.next()}`}
        />
      </div>
    );
  }

  public getEditorialItemClassName = (): string => "Editorial all-cell-1-1 uitk-cell all-y-padding-three";
}

export default DynamicVendorContent;
